import { useIntl } from 'react-intl';

import { Mail } from '@calm-web/icons';

import { useAuth } from '@/hooks/auth/useAuth';
import { useAuthFormModeState } from '@/hooks/store/useAppState';
import useIsCalmSleepApp from '@/hooks/useIsCalmSleepApp';
import { CalmAuthMethods } from '@/utils/privacyCookies';

import messages from './messages';
import { Wrapper } from './styles';
import { EmailAuthButtonProps } from './types';

const EmailAuthButton = ({
	marketingOptIn,
	onAuthSuccess,
	buttonCTA,
	loginHint,
	isDarkBackground,
}: EmailAuthButtonProps) => {
	const { authenticate, isAuth0Enabled } = useAuth();
	const { formatMessage } = useIntl();
	const authFormMode = useAuthFormModeState();

	const getButtonCta = () => {
		if (buttonCTA) {
			return typeof buttonCTA === 'string' ? buttonCTA : formatMessage(buttonCTA);
		}
		if (isAuth0Enabled) {
			return authFormMode === 'login'
				? formatMessage(messages.emailSignInCta)
				: formatMessage(messages.emailContinueCta);
		}

		return formatMessage(messages.emailContinueCta);
	};

	const handleClick = () => {
		authenticate({ authMethod: CalmAuthMethods.Email, marketingOptIn, onAuthSuccess, loginHint });
	};

	const buttonCta = getButtonCta();

	const isCalmSleepApp = useIsCalmSleepApp();

	const blue = isCalmSleepApp ? 'calmSleepAppBlue' : 'blue7';

	return (
		<Wrapper
			$noPadding={false}
			backgroundColor={isDarkBackground ? 'white' : blue}
			borderColor={isDarkBackground ? 'white' : blue}
			textColor={isDarkBackground ? 'black' : 'white'}
			iconColor={isDarkBackground ? 'black' : undefined}
			contentAlignment="center"
			data-testid="email-button"
			Icon={Mail}
			onPress={handleClick}
			role="link"
		>
			{buttonCta}
		</Wrapper>
	);
};

export default EmailAuthButton;
